import { render, staticRenderFns } from "./latestyearpurprice.vue?vue&type=template&id=262baf42&scoped=true&"
import script from "./latestyearpurprice.vue?vue&type=script&lang=js&"
export * from "./latestyearpurprice.vue?vue&type=script&lang=js&"
import style0 from "./latestyearpurprice.vue?vue&type=style&index=0&id=262baf42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262baf42",
  null
  
)

export default component.exports